// noinspection DuplicatedCode

import React, { useEffect, useState } from "react";

import { Colors } from "../../../assets/Colors";
import { fetchGet, fetchPostSilance } from "../../../fetchers";
import { useMutation } from "@tanstack/react-query";
import { DynamicTableExtendProcurment } from "../../../components/tablecard/DynamicTable";
import { Card } from "@material-tailwind/react";
import Button from "@material-tailwind/react/Button";
import "react-toastify/dist/ReactToastify.css";
import { maxPageGlobal } from "../../../assets/config";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalBody from "@material-tailwind/react/ModalBody";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Modal from "@material-tailwind/react/Modal";
import { useForm } from "../../../components/isRequired";

const AllocationPurchaseRequisitionPage = ({}) => {
  let initialState = {};
  const validations = [];

  const bisnisUnit = useMutation((formData) =>
    fetchGet("getMinMasterBisnisUnit")
  );

  const [search, setSearch] = useState("");
  const [dataUpkeep, setdataUpkeep] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [detail, setDetail] = useState({});
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    BisnisUnitID: "U0002",
    Menu: "Allocation",
  });
  const params = useParams();

  const mutationData = useMutation((param) =>
    fetchPostSilance("Procurement/PurchaseRequisition/table", param)
  );
  const mutationUserPC = useMutation((param) =>
    fetchGet("Master/UserPC/min", param)
  );
  const allocation = useMutation((param) =>
    fetchPostSilance("Procurement/PurchaseRequisition/Kirim", param)
  );

  const [showModalEdit, setShowModalEdit] = useState(false);

  useEffect(() => {
    bisnisUnit.mutate();
    mutationUserPC.mutate();
    if (params.id) {
      setParam({
        start: parseInt(0),
        count: parseInt(maxPageGlobal),
        search: search,
        Menu: "Allocation",
        BisnisUnitID: params.id,
      });
    }
  }, []);

  const {
    values,
    touched,
    customHandler,
    changeHandler,
    errors,
    editHandler,
    clearHandler,
    blastChange,
  } = useForm(initialState, validations);

  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(param, {
      onSuccess: async (data, context) => {
        let calc = data?.count - 1;
        if (calc === 0) {
          calc = 1;
        }

        if (calc % count === 0) {
          calc = calc + 1;
        }

        let tempMaxPage = data.data ? Math.ceil(calc / count) : 1;
        setMaxPage(tempMaxPage);
      },
    });
  }, [param]);

  const [buttonTouched, setButtonTouched] = useState(false);

  const header = [
    {
      name: "Purchase Requisition ID",
      key: "PurchaseRequisitionID",
      modifiers: "Text",
    },
    { name: "Bisnis Unit", key: "NamaBisnisUnit", modifiers: "Text" },
    { name: "Date PR", key: "DatePR", modifiers: "Date" },
    { name: "Requester", key: "Requester", modifiers: "Text" },
    { name: "Remarks", key: "Remarks", modifiers: "Text" },
    { name: "Status", key: "STATUS", modifiers: "Text" },
    { name: "Tipe", key: "Tipe", modifiers: "Text" },
    { name: "Edit", key: "Edit", modifiers: "Button" },
  ];

  const navigate = useNavigate();

  const filterData = (event) => {
    const filtered = mutationData.data.filter(({ NamaKaryawan }) =>
      NamaKaryawan.toLowerCase().includes(event.target.value.toLowerCase())
    );
    setdataUpkeep(filtered);
  };

  const ModalOpener = (detail) => {
    //
    // navigate("/procurment/transaction/form-allocation/" + param.BisnisUnitID + "/" + detail)
  };

  const editOpener = (detail) => {
    //
    navigate(
      "/procurment/transaction/form-allocation/" +
        param.BisnisUnitID +
        "/" +
        detail.replaceAll("/", "-")
    );
  };

  function handleUpdatePage(newPage) {
    let newStart = newPage * count - count;

    setParam({
      start: newStart,
      count: count,
      search: "",
      Menu: "Allocation",
      BisnisUnitID: param.BisnisUnitID,
    });
  }

  function handleUpdateCount(newCount) {
    let calc = count - 1;
    if (calc === 0) {
      calc = 1;
    }
    setParam({
      start: parseInt(newCount === "-1" ? 0 : start),
      count: parseInt(newCount === "-1" ? count : newCount),
      search: search,
      Menu: "Allocation",
      BisnisUnitID: param.BisnisUnitID,
    });
    setPage(newCount === "-1" ? 0 : start);
    setStart(newCount === "-1" ? count : newCount);
    setSearch(search);
    setPage(1);
    setCount(newCount === "-1" ? count : newCount);
    setStart(newCount === "-1" ? 0 : start);
    setMaxPage(newCount === "-1" ? 1 : Math.ceil(calc / newCount));
  }

  function handleModal(value) {
    const Kirim = {
      PurchaseRequisitionID: value,
    };
    allocation.mutate(Kirim, {
      onSuccess: () => {
        setShowModal(false);
        setShowModalEdit(false);

        toast.info("Loading table!", {
          position: "top-center",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          theme: "light",
        });

        mutationData.mutate(param);
        clearHandler();
        setShowModal(false);
      },
    });
  }

  return (
    <div className="md:ml-64">
      <div
        style={{ background: Colors.primary }}
        className="pt-14 pb-16 px-3 md:px-8 h-auto"
      >
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
        </div>
      </div>
      <div className="px-3 md:px-8 h-auto -mt-32">
        <div className="container mx-auto max-w-full">
          <div className="grid grid-cols-1 px-4">
            <Card>
              <div className="flex flex-col  content-center ">
                {bisnisUnit.data && (
                  <div className={"w-full md:w-1/3 px-3"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Bisnis Unit
                    </label>

                    <Select
                      value={bisnisUnit.data.data.filter(
                        ({ value }) => value === param.BisnisUnitID
                      )}
                      name={"BisnisUnitID"}
                      className={
                        "appearance-none block w-full  text-gray-700 border border-main-100  outline-none bg-white"
                      }
                      onChange={(text) =>
                        setParam({
                          start: parseInt(0),
                          count: parseInt(maxPageGlobal),
                          search: search,
                          Menu: "Allocation",
                          BisnisUnitID: text.value,
                        })
                      }
                      options={bisnisUnit.data.data}
                    />
                  </div>
                )}
                <DynamicTableExtendProcurment
                  types="Allocation"
                  data={mutationData.data}
                  header={header}
                  menuController={filterData}
                  Master={false}
                  currentPage={page}
                  maxPage={maxPage}
                  name={"UserPC"}
                  OnClick={ModalOpener}
                  updateCount={handleUpdateCount}
                  count={count}
                  updatePage={handleUpdatePage}
                  editor={editOpener}
                  modal={handleModal}
                  loadingButton={allocation.isLoading}
                />
              </div>
            </Card>
            <Modal
              size="lg"
              active={showModal}
              toggler={() => {
                setShowModal(true);
              }}
            >
              <ModalHeader
                className="mt-20"
                toggler={() => {
                  setShowModal(false);
                  setShowModalEdit(false);
                }}
              >
                Allocation
              </ModalHeader>
              <ModalBody>
                <form className="w-full">
                  <HrdInputGenerator
                    type={"text"}
                    value={values}
                    name={"PurchaseRequisitionID"}
                    title={"Purchase Requisition ID"}
                    touched={touched}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    errors={errors}
                    disabled={true}
                  />
                  <HrdInputGenerator
                    type={"userPC"}
                    value={values}
                    name={"UserPCID"}
                    title={"UserPC"}
                    touched={touched}
                    onChange={customHandler}
                    buttonTouched={buttonTouched}
                    size={"full"}
                    errors={errors}
                  />
                </form>
              </ModalBody>
              <ModalFooter>
                <Button
                  color="red"
                  buttonType="link"
                  onClick={() => {
                    setShowModal(false);
                  }}
                  ripple="dark"
                >
                  Cancel
                </Button>

                <Button
                  className={"bg-green-700 disabled:bg-red-400"}
                  disabled={!values["UserPCID"]}
                  onClick={() => {
                    if (values["UserPCID"]) {
                      allocation.mutate(values, {
                        onSuccess: () => {
                          setShowModal(false);
                          setShowModalEdit(false);

                          toast.info("Loading table!", {
                            position: "top-center",
                            autoClose: 1000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            theme: "light",
                          });

                          mutationData.mutate(param);
                          clearHandler();
                          setShowModal(false);
                        },
                      });
                    }
                  }}
                >
                  {allocation.isLoading ? (
                    <>
                      <svg
                        aria-hidden="true"
                        role="status"
                        className="inline mr-3 w-4 h-4 text-white animate-spin"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="#E5E7EB"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="current
                                       Color"
                        />
                      </svg>
                      Loading
                    </>
                  ) : (
                    "Set Allocation dan Kirim"
                  )}
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AllocationPurchaseRequisitionPage;
